export default __webpack_public_path__ + "static/media/bg-blog.f46cacbe.png";